const light = {
  colors: {
    AREA_BG: '#f5f5f5',

    PROGRESS_BG: 'rgba(0,0,0,0.2)',
    PROGRESS_OVERLAY_BG: 'rgba(0,0,0,0.1)',

    MENU_BG: '#222',
    MENU_TEXT: '#fff',
    MENU_LINK_BG: 'rgba(0,0,0,0.02)',
    MENU_LINK_BG_HOVER: '#000',
    MENU_LINK_TEXT: '#fff',
    MENU_LINK_TEXT_HOVER: '#fff',
    MENU_IC: '#f5f5f5',
    MENU_VERSION: '#666',

    HEADER_BG: '#fff',
    HEADER_TEXT: '#333',
    HEADER_IC: '#333',
    HEADER_SEARCH_COLOR: '#333',
    HEADER_BUTTON_BG: '#EEE',
    HEADER_BUTTON_TEXT: '#fff',
    HEADER_BUTTON_BG_HOVER: 'rgba(0,0,0,0.1)',
    HEADER_BUTTON_TEXT_HOVER: '#333',
    HEADER_PLUS: '#333',

    BUTTON_BG: '#333',
    BUTTON_TEXT: '#FFF',
    BUTTON_BG_HOVER: '#000',
    BUTTON_TEXT_HOVER: '#fff',

    SESSION_TITLE: '#fff',
    SESSION_SUBTITLE: '#666',
    SESSION_BACK_BG: '#f15825',
    SESSION_BACK_BG_HOVER: '#333',
    SESSION_BACK_TEXT: '#333',

    GRID_BG: 'rgba(0,0,0,0.1)',
    GRID_HEAD_ITEM_BG: 'rgba(0, 0, 0, 0.01)',
    GRID_HEAD_ITEM_TEXT: '#333',
    GRID_ITEM_TEXT: '#333',
    GRID_ITEM_TEXT_BOLD: '#333',
    GRID_MENU_IC: '#333',

    GRADIEN_COLOR_1: '#444',
    GRADIENT_COLOR_2: '#000',
    GRADIENT_CIRCLE: 'rgb(21 116 25 / 10%)',

    COLLAPSE_COLOR1: '#FFF',
    COLLAPSE_COLOR2: '#eee',
    COLLAPSE_IC: '#fff',

    FORM_LABEL_IC_BG_ENABLE: 'rgba(0,0,0,0.1)',
    FORM_LABEL_IC_BG: 'rgba(0, 0, 0, 0.05)',
    FORM_LABEL_IC: '#333',
    FORM_LABEL_IC_ENABLE: '#333',
    FORM_LABEL_TITLE: '#333',
    FORM_LABEL_SUBTITLE: '#666',

    FORM_INPUT_TEXT: '#333',
    FORM_INPUT_BG: 'rgba(255,255,255,0.01)',
    FORM_INPUT_PLACEHOLDER: '#ccc',

    FORM_CANCEL_TEXT: '#666',

    FORM_SORTABLE_ITEM_TEXT: '#333',

    PROGRESSBAR_BG_1: '#FFFFFF95',
    PROGRESSBAR_BG_2: '#ffffff75',
    PROGRESSBAR_BAR_BG_1: '#ccc',
    PROGRESSBAR_BAR_BG_2: '#fff',
    PROGRESSBAR_PERCENT_BG: '#f15825',
    PROGRESSBAR_BG_MOBILE: '#FFF',

    DIALOG_BG_MOBILE: '#fff',
    DIALOG_BG_1: 'rgba(255,255,255,0.9)',
    DIALOG_BG_2: 'rgba(255,255,255,0.8)',
    DIALOG_WAVE: '#f1582520',

    DROP_IC: '#333',
    DROP_BORDER: 'rgba(0,0,0,0.1)',
    DROP_TEXT: '#333',
  },
};

export default light;
